<template>
  <div class="contentBox">
    <div class="breadCrumbs mt-50">
      <el-breadcrumb separator="/" class="ml-15">
        <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
        <el-breadcrumb-item>newsMain</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="newsMain">
      <div class="mainLeft">
        <h1 class="title">{{responsedata.title}}</h1>
        <p class="view">
          <span>
            <i class="el-icon-time"></i>
            {{responsedata.document_time}}
          </span>
          <span>
            <i class="el-icon-view"></i>
            {{responsedata.view}}
          </span>
        </p>
        <div class="content" v-html="responsedata.content"></div>
        <div class="pageTurning">
          <span v-if='responsedata.pann.pre.length != 0' @click="pageTurningFn(responsedata.pann.pre.id)">上一篇：{{responsedata.pann.pre.title}}</span>
          <span v-if='responsedata.pann.next.length != 0' @click="pageTurningFn(responsedata.pann.next.id)">下一篇：{{responsedata.pann.next.title}}</span>
        </div>
      </div>
      <div class="mainRight">
        <div class="hostArticles">
          <div class="titletop">
            <img src="@/assets/images/hostIcon.png">
            <p>Hot articles</p>
          </div>
          <ul class="articlesList">
            <li v-for="(item,key) in articlesList" :key="key">
            
              <div class="articlesimgBox">
                <img :src="item.cover" class="articlesimg">
              </div>
              <div class="articlesText">
                <p class="p1" @click="updateFn(item.id)">{{item.title}}</p>
<!--                <p class="p2">{{item.document_time}}</p>-->
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import apiSign from "../assets/js/apiSign";
import { mapState } from "vuex";

export default {
  name: "membersMain",
  data() {
    return {
      articlesList:{},
      responsedata: "",
      newsid: "",
    };
  },

  mounted() {
    this.newsid = this.$route.params.id;
    this.getDefaultActiclesFn();
    this.gethotDataFn()
  },
  methods: {
    getDefaultActiclesFn() {
      let newsId = this.newsid;
      if(newsId == undefined){
        newsId = sessionStorage.getItem('newsid'); 
      }
      let field = { rtime: apiSign.getTime(), id: newsId };
      this.axios
        .get(this.axios.defaults.baseURL + "/yiwei/news/info", {
          headers: {
            sign: apiSign.sign(field)
          },
          params: field
        })
        .then(resp => {
          console.log('resp: ', resp);
          let content = resp.data.data.content
          content.replace('/uploads/', "http://admin.gzhmu-ygz-group.cn/uploads/")
          console.log('content',content)
          this.responsedata = resp.data.data;
        });
    },
    gethotDataFn(){
      let field = { rtime: apiSign.getTime()};
      this.axios.get(this.axios.defaults.baseURL + "/yiwei/app/getHotArticle", {
        headers: {
          sign: apiSign.sign(field)
        },
        params: field
      }).then(resp=>{
        this.articlesList = resp.data.data;
      });
    },
    pageTurningFn(id){
      let newsId =id;
      if(newsId == undefined){
        newsId = sessionStorage.getItem('newsid'); 
      }
      let field = { rtime: apiSign.getTime(), id: newsId };
      this.axios
        .get(this.axios.defaults.baseURL + "/yiwei/news/info", {
          headers: {
            sign: apiSign.sign(field)
          },
          params: field
        })
        .then(resp => {
          this.responsedata = resp.data.data;
          let timer = setInterval(function() {
            var scrollTop =
              document.documentElement.scrollTop || document.body.scrollTop;
            var ispeed = Math.floor(-scrollTop / 6);
            if (scrollTop == 0) {
              clearInterval(timer);
            }
            document.documentElement.scrollTop = document.body.scrollTop =
              scrollTop + ispeed;
          }, 30);
        });
    },
    updateFn(id){
      this.newsid = id;
      this.getDefaultActiclesFn()
    }
  }
};
</script>
